import React from "react";
import {
  Container,
  Box,
  Typography,
  List,
  ListItem,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CookiePolicyPage = () => {
  const { t } = useTranslation();
  const sections = t("cookiePolicy.sections", { returnObjects: true }) || [];

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: 900,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        <Typography variant="h3" color="primary" gutterBottom>
          {t("cookiePolicy.title")}
        </Typography>
        {t("cookiePolicy.updated") && (
          <Typography variant="body2" color="text.secondary">
            {t("cookiePolicy.updated")}
          </Typography>
        )}

        <Divider sx={{ my: 3 }} />

        {sections.map((sec, i) => (
          <Box key={i} sx={{ mb: 3 }}>
            {sec.title && (
              <Typography variant="h5" color="primary" gutterBottom>
                {sec.title}
              </Typography>
            )}

            {Array.isArray(sec.paragraphs) &&
              sec.paragraphs.map((p, j) => (
                <Typography key={j} variant="body1" paragraph>
                  {p}
                </Typography>
              ))}

            {Array.isArray(sec.list) && sec.list.length > 0 && (
              <List dense>
                {sec.list.map((li, k) => (
                  <ListItem key={k} sx={{ pl: 0 }}>
                    <Typography variant="body2">{li}</Typography>
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default CookiePolicyPage;
